import { createSlice } from '@reduxjs/toolkit'

import { siteMapNavItem } from '../types/siteMap'
import { siteMaps } from '../site-maps'
import { getSiteMap, itemExistsInNav } from '../utils'

const initialState = {
  map: 'start',
  nav: <siteMapNavItem[]>[],
}

export const siteMapSlice = createSlice({
  name: 'siteMap',
  initialState: initialState,
  reducers: {
    updateNav: (state, action) => {
      const siteMap: siteMapNavItem[] = getSiteMap(initialState.map)
      let update = action.payload
      if (update && Array.isArray(update)) {
        // replace the whole nav
        state.nav = action.payload
      } else if (
        update &&
        update.id &&
        !itemExistsInNav(update.id, state.nav)
      ) {
        // update a single nav item based on object
        state.nav = [...state.nav, action.payload]
      } else if (update && typeof update === 'string') {
        // update a single nav item based on id
        const navItem = siteMap.find(
          (item: siteMapNavItem) => item.path === update
        )
        state.nav =
          navItem && !itemExistsInNav(navItem.id, state.nav)
            ? [...state.nav, navItem]
            : state.nav
      } else {
        // add a random item to the nav
        const remainingNavIds = siteMap.filter(
          (mapItem: any) =>
            !state.nav.find((navItem) => navItem.id === mapItem.id)
        )
        if (remainingNavIds && remainingNavIds.length) {
          const item =
            remainingNavIds[Math.floor(Math.random() * remainingNavIds.length)]
          state.nav = [...state.nav, item].sort(
            (a: siteMapNavItem, b: siteMapNavItem) => a.id - b.id
          )
        } else {
          return state
        }
      }
    },
    clearSiteMap: (state) => {
      return initialState
    },
  },
})

export const { updateNav, clearSiteMap } = siteMapSlice.actions

export default siteMapSlice.reducer
